<script>
  import { onMount } from 'svelte';
  import { page } from '$app/stores';
  import { userStore } from '$lib/store/user';

  const appConfig = $page.data.appConfig;

  let render = false;

  onMount(() => {
    const errorRedirect = appConfig?.preferences?.externalErrorRedirect;
    if (errorRedirect) {
      window.location.href = errorRedirect;
    } else {
      if ($userStore.loggedIn) {
        const logoutEvent = new CustomEvent('array-event', {
          // Fire logout event, will be handled the same way as if a component fired a logout event
          detail: { event: 'logout' },
        });
        window.dispatchEvent(logoutEvent);
      }
      render = true;
    }
  });
</script>

{#if render}
  <div class="container error-page">
    <div class="content">
      <div class="error-icon">
        <svg
          width="47px"
          height="46px"
          viewBox="0 0 47 46"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="UI-Design"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="1.1-d1-Error-Equ-Desktop"
              transform="translate(-696.000000, -327.000000)"
              fill="#FF3C3C"
            >
              <g
                id="Icons-/-24px-/-Error"
                transform="translate(685.500000, 316.000000)"
              >
                <path
                  d="M34,11.3333333 C46.270422,11.3333333 56.3027524,21.0950872 56.6573868,33.3494753 L56.6573868,33.3494753 L56.6666667,34 C56.6666667,46.270422 46.9049128,56.3027524 34.6505247,56.6573868 L34.6505247,56.6573868 L34,56.6666667 C21.4806674,56.6666667 11.3333333,46.5201837 11.3333333,34 C11.3333333,21.729578 21.0950872,11.6972476 33.3494753,11.3426132 L33.3494753,11.3426132 Z M33.9999413,14.9122187 L33.4364044,14.9203651 C23.1327288,15.2186525 14.9122187,23.6670189 14.9122187,33.9999413 C14.9122187,44.543385 23.4572144,53.0877813 33.9837108,53.0877813 L33.9837108,53.0877813 L34.5634783,53.0795176 C44.8671538,52.7812302 53.0877813,44.3328638 53.0877813,34.0161718 L53.0877813,34.0161718 L53.0795176,33.4364044 C52.7812302,23.1327288 44.3328638,14.9122187 33.9999413,14.9122187 L33.9999413,14.9122187 Z M34,38.7113851 C35.5155697,38.7791804 36.7094245,40.0276331 36.7094245,41.5447184 C36.7094245,43.0618037 35.5155697,44.3102565 34,44.3780518 C32.4844303,44.3102565 31.2905755,43.0618037 31.2905755,41.5447184 C31.2905755,40.0276331 32.4844303,38.7791804 34,38.7113851 Z M34.125,21.7113851 C35.2295695,21.7113851 36.125,22.6068156 36.125,23.7113851 L36.125,23.7113851 L36.125,33.8780518 C36.125,34.9826213 35.2295695,35.8780518 34.125,35.8780518 L34.125,35.8780518 L33.875,35.8780518 C32.7704305,35.8780518 31.875,34.9826213 31.875,33.8780518 L31.875,33.8780518 L31.875,23.7113851 C31.875,22.6068156 32.7704305,21.7113851 33.875,21.7113851 L33.875,21.7113851 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="text">Hang on, an error occurred.</div>
      <div class="text">
        Our team has been notified and is working to sort out the issue.
      </div>
      <div class="text">Please try again later.</div>
    </div>
  </div>
{/if}

<style>
  .container {
    height: 100%;
    font-family: 'Heebo', 'Roboto', 'Open Sans', serif;
    color: #3e3f42;
  }

  .error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }

  .error-page .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 1;
  }

  @media screen and (min-width: 320px) and (max-width: 576px) {
    .error-page .content {
      padding: 22px 0;
    }
  }

  .error-page .error-icon {
    margin-bottom: 10px;
  }

  .error-page .text {
    color: #3e3f42;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 0.5em;
  }

  /* heebo-regular - latin */
  @font-face {
    font-family: 'Heebo';
    font-style: normal;
    font-weight: 400;
    src: url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.eot'); /* IE9 Compat Modes */
    src: local('Heebo'), local('Heebo-Regular'),
      url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.eot?#iefix')
        format('embedded-opentype'),
      /* IE6-IE8 */
        url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.woff2')
        format('woff2'),
      /* Super Modern Browsers */
        url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.woff')
        format('woff'),
      /* Modern Browsers */
        url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.ttf')
        format('truetype'),
      /* Safari, Android, iOS */
        url('https://cdn-web-assets.array.io/assets/fonts/heebo-v5-latin-regular.svg#Heebo')
        format('svg'); /* Legacy iOS */
    font-display: swap;
  }
</style>
